import Vue from 'vue'
import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'
import { tenantName } from '../helpers/helpers'

Vue.use ( {
  install (vue) {
    const apiGraphqlUrl = `https://${tenantName}.${process.env.VUE_APP_API_BASE_URL}/graphql`

    const httpLink = createHttpLink({
      uri: apiGraphqlUrl
    })

    const authLink = setContext((_, { headers }) => {
      const tokenAPI = process.env.VUE_APP_API_TOKEN
      return {
        headers:{
          ...headers,
          Authorization: tokenAPI ? `Bearer ${tokenAPI}` : ''
        }
      }
    })

    Vue.prototype.$api = new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache()
    })
  }
})
